import Toastr from "../../../itrust_common/components/Toastr"

const PARENT = 'MARKETING_BLAST_'

const DEFAULT_STATE = {
  transactions: [],
  meta: { pagination: {} },
  saving: false,
  loading: false,
  editing: false
}

let changes = null;
export default function walletAndBillingReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {
    case `${PARENT}WALLET_FUND_CREATE_PENDING`:
      return { ...state, saving: true };
    case `${PARENT}TRANSACTIONS_LOAD_PENDING`:
      return { ...state, loading: true };

    case `${PARENT}TRANSACTIONS_LOAD_REJECTED`:
    case `${PARENT}WALLET_FUND_CREATE_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = {
        saving: false,
        loading: false
      }
      return { ...state, ...changes };

    case `${PARENT}WALLET_FUND_CREATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      changes = {
        transactions: [response.transaction, ...state.transactions],
        saving: false
      }
      return { ...state, ...changes };

    case `${PARENT}TRANSACTIONS_LOAD_FULFILLED`:
      changes = { ...response, loading: false }
      return { ...state, ...changes };

    default:
      return state;
  }
}